import { render, staticRenderFns } from "./MonitorNewMilestone.vue?vue&type=template&id=aacd81c6&"
import script from "./MonitorNewMilestone.vue?vue&type=script&lang=js&"
export * from "./MonitorNewMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports